export const getLocalesErrorCount = ({
  isNBAFeatureEnabled,
  nbaLocalesErrors,
  allContentErrors,
}: {
  isNBAFeatureEnabled: boolean;
  nbaLocalesErrors: string[];
  allContentErrors: string[];
}) => {
  if (isNBAFeatureEnabled && nbaLocalesErrors?.length > 0) {
    return nbaLocalesErrors?.length;
  } else {
    return allContentErrors?.length;
  }
};
